import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

// Third party Modules
import {FilterPipeModule} from 'ngx-filter-pipe';
import {ImageCropperModule} from 'ngx-image-cropper';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';

import {NgxSliderModule} from '@angular-slider/ngx-slider';

// Highchart modules
import {ChartModule, HIGHCHARTS_MODULES} from 'angular-highcharts';
import * as HighChartsMore from 'highcharts/highcharts-more.src';
import * as highstock from 'highcharts/modules/stock.src';
import * as solidGauge from 'highcharts/modules/solid-gauge.src'; // used in step graph on patient overview
import * as variablepie from 'highcharts/modules/variable-pie.src';
import {HIGH_CHARTS} from '../components/highchart/highcharts';

import * as seriesLabel from 'highcharts/modules/series-label.src';

import {MaterialModules} from '../core/imports/materialModules';
import {QRCodeModule} from 'angularx-qrcode';
import {QuillModule} from 'ngx-quill';
import {RouterModule} from '@angular/router';
import {HighchartsModule} from '../components/highchart/highcharts.module';
import {GetFrequencyPipe} from '../core/pipes/date-formatter/get-frequency.pipe';
import {SharedComponentsModule} from './components/shared-components.module';

@NgModule({
  declarations: [...HIGH_CHARTS],
  imports: [
    CommonModule,
    QRCodeModule,
    ChartModule,
    RouterModule,
    SharedComponentsModule,
    FilterPipeModule,
    ImageCropperModule,
    InfiniteScrollModule,
    QuillModule,
    NgxSliderModule,
    NgxSkeletonLoaderModule,
    HighchartsModule,
  ],
  exports: [
    ChartModule,
    FilterPipeModule,
    ImageCropperModule,
    InfiniteScrollModule,
    MaterialModules,
    QuillModule,
    NgxSliderModule,
    QRCodeModule,
    NgxSkeletonLoaderModule,
    ...HIGH_CHARTS,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
  ],
  providers: [
    {
      provide: HIGHCHARTS_MODULES,
      useFactory: () => [HighChartsMore, variablepie, highstock, solidGauge, seriesLabel],
    }, // add as factory to your providers
    GetFrequencyPipe,
  ],
})
export class SharedModule {}
